const tableTitleGroup = {
  title: 'Groups',
  placeholder: 'Search by group',
  Typography: 'no results found'
};

export default tableTitleGroup;
